<template>
  <div>

    <Head />
    <div class="content">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="150px" class="demo-ruleForm"
        style="width:1500px">
        <!-- 商品名称（中文 -->
        <el-form-item :label="$t('message.productNameChinese') + ':'" prop="title">
          <el-input v-model="ruleForm.title"></el-input>
        </el-form-item>
        <!-- 商品名称（中文 -->
        <el-form-item :label="$t('message.productNameJapanese') + ':'">
          <el-input v-model="ruleForm.title_jp"></el-input>
        </el-form-item>
        <!--商品链接 -->
        <el-form-item :label="$t('message.ProductLink') + ':'">
          <el-input v-model="ruleForm.link"></el-input>
        </el-form-item>
        <!--供应商名称 -->
        <el-form-item :label="$t('message.supplierName') + ':'">
          <el-input v-model="ruleForm.supplier_name"></el-input>
        </el-form-item>
        <!--状态 -->
        <el-form-item :label="$t('message.itemStatus') + ':'" prop="status_convert">
          <el-switch v-model="ruleForm.status_convert" active-color="#13ce66">
          </el-switch>
        </el-form-item>
        <!--商品分类   -->
        <el-form-item :label="$t('message.productCategory') + ':'" prop="classify_id">
          <el-cascader :options="classifyOption"
            :props="{ checkStrictly: true, children: 'childs', label: 'name', value: 'id' }" v-model="classifyIds"
            clearable placeholder="选择分类" @change="handleChange" style="width: 400px;" filterable>
          </el-cascader>
        </el-form-item>
        <!--所属货盘 -->
        <el-form-item :label="$t('message.associatedInventory') + ':'">
          <el-select v-model="ruleForm.pallet_config_ids" placeholder="选择货盘" multiple style="width: 400px;">
            <el-option v-for="item in palletyOption" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <!--商品图片 -->
        <el-form-item :label="$t('message.productPicture') + ':'" prop="pic">
          <div class="img">
            <el-image style="width: 100px;height: 100px;border-radius: 6px; margin-right: 12px;" :src="ruleForm.pic"
              :preview-src-list="[ruleForm.pic]">
              <div slot="error" class="image-slot">
                <i class="el-icon-plus"></i>
              </div>
            </el-image>
            <!-- 编辑 -->
            <div class="redact">
              <el-upload class="upload-demo" ref="upload" action="https://jsonplaceholder.typicode.com/posts/"
                :before-upload="befoUpload" :show-file-list="false" :http-request="httpup">
                <el-button type="text" slot="trigger">{{ $t('message.redact') }}</el-button>
              </el-upload>
            </div>
          </div>
        </el-form-item>
        <!--副图 -->
        <el-form-item :label="$t('message.SupplementaryImage') + ':'">
          <div class="imgList">
            <div class="item" v-for="(item, index) in ruleForm.imgList" :key="index">
              <el-image style="width: 100px;height: 100px;border-radius: 6px; margin-right: 12px;" :src="item"
                :preview-src-list="[item]">
              </el-image>
              <i class="el-icon-circle-close" @click="ruleForm.imgList.splice(index, 1)"></i>
            </div>
            <el-upload action="https://jsonplaceholder.typicode.com/posts/" list-type="picture-card" multiple drag
              :http-request="httpupimgList" :show-file-list="false">
              <i class="el-icon-plus"></i>
            </el-upload>
          </div>
        </el-form-item>
        <!--商品属性 -->
        <el-form-item :label="$t('message.commodityAttribute') + ':'">
          <!-- 创建属性 -->
          <div class="operation" v-if="isAdd">
            <el-button type="success" size="mini" @click="createAttribute">{{ $t('message.createAttribute')
            }}</el-button>
            <!-- 生成SKU组合 -->
            <el-button type="primary" size="mini" @click="addSku">{{ $t('message.generateSkuCombination') }}</el-button>
          </div>
          <!-- 属性 -->
          <div class="attribute">
            <div class="row" v-for="(item, index) in attribute" :key="index">
              <div class="item">
                <div class="title">
                  SKU名称
                </div>
                <div class="val">
                  <el-input v-model="item.key" :readonly="!isAdd"> </el-input>
                </div>
              </div>
              <div class="item" v-for="(val, valIndex) in item.value" :key="valIndex">
                <div class="title">
                  值{{ valIndex + 1 }}
                  <el-button type="text" @click="deleteVal(index, valIndex)" v-if="isAdd">{{ $t('message.delete')
                  }}</el-button>
                </div>
                <div class="val">
                  <el-input v-model="val.name" :readonly="!isAdd"> </el-input>
                </div>
                <!-- 图片 -->
                <div class="img-box">
                  <el-upload class="upload-demo" ref="upload" action="https://jsonplaceholder.typicode.com/posts/"
                    :before-upload="befoUpload" :show-file-list="false" :http-request="httpPicUrl"
                    v-if="!val.picUrl && isAdd">
                    <el-button slot="trigger" type="success"
                      @click="attributeIndex.index = index; attributeIndex.valIndex = valIndex">{{
                        $t('message.imageUpload') }}</el-button>
                  </el-upload>
                  <div class="img" v-if="val.picUrl">
                    <el-image style="width: 100px;height: 100px;border-radius: 6px; margin-right: 12px;"
                      :src="val.picUrl" :preview-src-list="[val.picUrl]">
                    </el-image>
                    <!-- 删除 -->
                    <div class="redact" v-if="isAdd">
                      <el-button type="text" slot="trigger" @click="delPicUrl(index, valIndex)">{{ $t('message.delete')
                      }}</el-button>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 增减 -->
              <div class="increaseDecrease" v-if="isAdd">
                <!-- 添加值 -->
                <el-button size="mini" type="success" @click="addValue(index)">{{ $t('message.addValue') }}</el-button>
                <!--  删除-->
                <el-button size="mini" type="success" class="dark" @click="deleteAttribute(index)">{{
                  $t('message.delete')
                }}</el-button>
              </div>
            </div>
          </div>
          <!-- 创建sku -->
          <div class="sku">
            <div class="skuItem" v-for="(item, index) in sku" :key="index">
              <div class="attr">
                <div class="name word-break">{{ item.attr.replaceAll('㊖㊎', '+') }}</div>
              </div>
              <div class="inventory">
                <div class="row">
                  <div class="item">
                    <div class="label">库存:</div>
                    <div class="value"><el-input v-model="item.quantity" type="number"></el-input></div>
                  </div>
                  <div class="item">
                    <div class="value"></div>
                    <el-button size="mini" type="success" @click="add_inventory_detail(index)">新增</el-button>
                  </div>
                </div>
                <div class="row" v-for="(items, indexs) in item.inventory_detail" :key="indexs">
                  <div class="item">
                    <div class="label">起批量:</div>
                    <div class="value"><el-input v-model="items.startQuantity" type="number"></el-input></div>
                  </div>
                  <div class="item">
                    <div class="label">单价(元):</div>
                    <div class="value"><el-input v-model="items.price" type="number"></el-input></div>
                    <i class="el-icon-delete" @click="del_inventory_detail(index, indexs)"></i>
                  </div>
                </div>
              </div>
              <!-- 删除一项 -->
              <div class="del" v-if="isAdd">
                <el-button class="dark" type="primary" @click="sku.splice(index, 1)">
                  {{ $t('message.delete') }}
                </el-button>
              </div>
            </div>
          </div>
        </el-form-item>
        <!--商品详细说明 -->
        <el-form-item :label="$t('message.productDetailedDescription') + ':'" prop="desc">
          <quill-editor ref="myTextEditor" id="quill-editor" v-model="ruleForm.desc" :options="quillOption">
          </quill-editor>
        </el-form-item>
      </el-form>
      <div class="btn">
        <!-- 保存 -->
        <el-button type="primary" @click="rakuProductStore" v-if="isAdd">{{ $t('message.save') }}</el-button>
        <el-button type="primary" @click="rakuProductUpdate" v-else>{{ $t('message.save') }}</el-button>
      </div>
    </div>
    <!-- 默认库存 -->
    <el-dialog :close-on-click-modal="false" :visible.sync="dialogVisible" width="688px" center>
      <div class="inventory">
        <div class="row">
          <div class="item">
            <div class="label">默认库存:</div>
            <div class="value"><el-input v-model="defaultValue.quantity" type="number"></el-input></div>
          </div>
          <div class="item">
            <div class="value"></div>
            <el-button size="mini" type="success" @click="addDefault">新增</el-button>
          </div>
        </div>
        <div class="row" v-for="(item, index) in defaultValue.inventory_detail" :key="index">
          <div class="item">
            <div class="label">起批量:</div>
            <div class="value"><el-input v-model="item.startQuantity" type="number"></el-input></div>
          </div>
          <div class="item">
            <div class="label">单价(元):</div>
            <div class="value"><el-input v-model="item.price" type="number"></el-input></div>
            <i class="el-icon-delete" @click="delDefault(index)"></i>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!-- 生成sku -->
        <el-button type="primary" @click="generateSkuCombination">
          {{ $t('message.generateSkuCombination') }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { quillEditor } from "vue-quill-editor";
import quillConfig from "@/utlis/quill-config";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import Head from './head'
export default {
  components: {
    quillEditor,
    Head
  },
  data() {
    return {
      quillOption: quillConfig,
      isAdd: true,
      dialogVisible: false,
      // 默认数据
      defaultValue: {
        quantity: '',
        inventory_detail: [
          { startQuantity: '', price: "" },
        ],
      },
      attribute: [],
      sku: [],
      attributeIndex: {
        index: 0,
        valIndex: 0,
      },
      ruleForm: {
        title: '',
        title_jp: '',
        link: '',
        pic: '',
        imgList: [],
        status_convert: true,
        desc: '',
        sku: [],
        classify_id: '',
        pallet_config_ids: [],
      },
      rules: {
        title: [{
          required: true,
          message: this.$t("message.TheRequired"),
          trigger: "blur",
        },],
        status_convert: [{
          required: true,
          message: this.$t("message.TheRequired"),
          trigger: "blur",
        },],
        desc: [{
          required: true,
          message: this.$t("message.TheRequired"),
          trigger: "blur",
        },],
        sku: [{
          required: true,
          message: this.$t("message.TheRequired"),
          trigger: "blur",
        },],
        pic: [{
          required: true,
          message: this.$t("message.TheRequired"),
          trigger: "blur",
        },],
        imgList: [{
          required: true,
          message: this.$t("message.TheRequired"),
          trigger: "blur",
        },],
        classify_id: [{
          required: true,
          message: this.$t("message.TheRequired"),
          trigger: "blur",
        },],
      },
      // 商品分类
      classifyOption: [],
      // 所属货盘:
      palletyOption: [],
      classifyIds: [],
    };
  },
  created() {
    let query = this.$route.query
    this.$api.siteConfiguration.classifyList().then(res => {
      this.classifyOption = res.data
      this.$forceUpdate()
    })
    this.$api.siteConfiguration.palletConfigList().then(res => {
      if (!query.goods_id) {
        res.data.forEach(item => {
          if (item.default_uses) {
            this.ruleForm.pallet_config_ids.push(item.id - 0)
          }
        })
      }
      this.palletyOption = res.data
    })
    if (query.goods_id) {
      this.rakuProductDetail(query.goods_id)
      this.isAdd = false
    }
  },
  methods: {
    // 商品详情
    rakuProductDetail(goods_id) {
      let ruleForm = {
        title: '',
        title_jp: '',
        link: '',
        pic: '',
        imgList: [],
        status_convert: true,
        desc: '',
        sku: [],
        classify_id: '',
        pallet_config_ids: [],
      }
      this.$api.siteConfiguration.rakuProductDetail({ goods_id }).then(res => {
        ruleForm = res.data
        ruleForm.imgList = res.data.images
        this.attribute = res.data.attribute
        this.sku = res.data.raku_product_sku
        ruleForm.classify_id = res.data.raku_classify.id
        if (res.data.raku_classify.parent_id) {
          this.classifyIds.push(res.data.raku_classify.parent_id)
        }
        this.classifyIds.push(res.data.raku_classify.id)
        ruleForm.status_convert = ruleForm.status === 1 ? true : false
        ruleForm.pallet_config_ids = []
        res.data.raku_product_pallet.forEach(item => {
          ruleForm.pallet_config_ids.push(item.pallet_config_id - 0)
        })
        this.ruleForm = JSON.parse(JSON.stringify(ruleForm))
        this.$forceUpdate()
      })
    },
    // 分类
    handleChange(e) {
      this.ruleForm.classify_id = e[e.length - 1]
    },
    // 创建属性
    createAttribute() {
      if (this.attribute.length > 10) return this.$message.error('最多加10个属性')
      this.attribute.push({
        key: "", value: [{
          name: '',
          picUrl: '',
        }]
      })
    },
    //删除属性
    deleteAttribute(index) {
      this.attribute.splice(index, 1)
      this.$forceUpdate()
    },
    // 新增值
    addValue(index) {
      if (this.attribute[index].value.length >= 10) return this.$message.error('每个属性最多加10个值')
      this.attribute[index].value.push({
        name: '',
        picUrl: '',
      })
    },
    // 删除值
    deleteVal(index, valIndex) {
      this.attribute[index].value.splice(valIndex, 1)
      this.$forceUpdate()
    },
    // 创建sku
    addSku() {
      // this.defaultValue = {
      //   quantity: '',
      //   inventory_detail: [
      //     { startQuantity: '', price: "" },
      //   ],
      // }
      this.dialogVisible = true
    },
    // 保存
    rakuProductStore() {
      this.ruleForm.status = this.ruleForm.status_convert ? 1 : 2
      if (this.attribute == false) return this.$message.error('请创建商品属性')
      if (this.sku == false) return this.$message.error('请生成组合sku')
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.$confirm(' 请确认商品信息是否正确，保存后商品属性将无法进行修改，只能修改价格与库存与商品基础信息，请确认商品信息无误！！！', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
            center: true
          }).then(() => {
            this.ruleForm.images = JSON.stringify(this.ruleForm.imgList)
            this.ruleForm.attribute = JSON.stringify(this.attribute)
            this.ruleForm.sku = JSON.stringify(this.sku)
            this.$api.siteConfiguration.rakuProductStore(this.ruleForm).then(res => {
              this.$message.success(res.msg)
              this.$router.push('/customizedProducts')
            })
          }).catch(() => {

          });
        }
      })
    },
    //编辑
    rakuProductUpdate() {
      this.ruleForm.status = this.ruleForm.status_convert ? 1 : 2
      if (this.attribute == false) return this.$message.error('请创建商品属性')
      if (this.sku == false) return this.$message.error('请生成组合sku')
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.$confirm(' 请确认商品信息是否正确，保存后商品属性将无法进行修改，只能修改价格与库存与商品基础信息，请确认商品信息无误！！！', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
            center: true
          }).then(() => {
            this.ruleForm.images = JSON.stringify(this.ruleForm.imgList)
            this.ruleForm.attribute = JSON.stringify(this.attribute)
            this.ruleForm.sku = JSON.stringify(this.sku)
            console.log(this.ruleForm);
            this.$api.siteConfiguration.rakuProductUpdate(this.ruleForm).then(res => {
              this.$message.success(res.msg)
              this.$router.push('/customizedProducts')
            })
          }).catch(() => {
          });
        }
      })
    },
    // 上传前
    befoUpload(file) {
      const isJPG =
        ["image/bmp",
          "image/jpeg",
          "image/png",
          "image/tiff",
          "image/gif",
          "image/x-pcx",
          "image/x-tga",
          "image/jpeg", // EXIF 通常嵌入在 JPEG 中
          "image/vnd.fpx",
          "image/svg+xml",
          "image/vnd.adobe.photoshop",
          "application/coreldraw", // CDR 通常是 application
          "image/x-photo-cd", // PCD
          "image/vnd.dxf", // 或 application/dxf
          "application/octet-stream", // UFO 无标准 MIME，常见为二进制流
          "application/postscript", // EPS
          "application/postscript", // AI 也可能用 application/illustrator
          "image/x-raw", // RAW 格式多样，无统一标准
          "image/wmf",
          "image/webp",
          "image/avif",
          "image/apng"].indexOf(file.type) != -1;
      if (!isJPG) {
        if (file.name.indexOf('HEIC') == -1) {
          this.$message.error("请上传图片");
          return isJPG;
        }
      }
    },
    // 上传
    async httpup(file) {
      let data = await this.createClient(file)
      this.ruleForm.pic = data.data
    },
    // 上传
    async httpupimgList(file) {
      if (this.ruleForm.imgList.length > 4) return this.$message.error('最多上传四张图片')
      let data = await this.createClient(file)
      this.ruleForm.imgList.push(data.data)
    },
    // 属性图片上传
    async httpPicUrl(file) {
      let data = await this.createClient(file)
      this.attribute[this.attributeIndex.index].value[this.attributeIndex.valIndex].picUrl = data.data
      this.$forceUpdate()
    },
    // 删除图片
    delPicUrl(index, valIndex) {
      this.attribute[index].value[valIndex].picUrl = ''
      this.$forceUpdate()
    },
    // 新增默认价格
    addDefault() {
      this.defaultValue.inventory_detail.push({ startQuantity: '', price: "" })
      this.$forceUpdate()
    },
    //删除默认价格
    delDefault(index) {
      this.defaultValue.inventory_detail.splice(index, 1)
      this.$forceUpdate()
    },
    // 新增sku 详情
    add_inventory_detail(index) {
      this.sku[index].inventory_detail.push({ startQuantity: '', price: "" })
      this.$forceUpdate()
    },
    // 删除sku详情
    del_inventory_detail(index, indexs) {
      this.sku[index].inventory_detail.splice(indexs, 1)
      this.$forceUpdate()
    },
    //生成sku
    generateSkuCombination() {
      this.sku = []
      if (this.attribute == false) return this.$message.error('未创建属性，无法生成')
      /**
       * 计算所有可能的组合（动态递归方法）
       * @param {Array} groups - 所有型号组
       * @param {number} currentIndex - 当前处理的组索引
       * @param {Array} currentCombination - 当前组合
       * @param {Array} results - 存储所有组合的结果
       */
      function generateCombinations(groups, currentIndex = 0, currentCombination = [], results = []) {
        if (currentIndex === groups.length) {
          results.push(currentCombination.join("㊖㊎"));
          return;
        }
        const currentGroup = groups[currentIndex].value;
        for (const option of currentGroup) {
          generateCombinations(
            groups,
            currentIndex + 1,
            [...currentCombination, option.name],
            results
          );
        }
        return results;
      }
      const allCombinations = generateCombinations(this.attribute);

      allCombinations.forEach((combo, index) => {
        // console.log(`${index + 1}. ${combo}`);
        let datas = {
          attr: combo, quantity: this.defaultValue.quantity, inventory_detail: this.defaultValue.inventory_detail
        }
        this.sku.push(JSON.parse(JSON.stringify(datas)))
      });
      this.dialogVisible = false
    },
  },
};
</script>
<style lang='scss' scoped>
.content {
  margin: 24px;
  padding-bottom: 50px;

  /deep/.el-radio__inner {
    transform: scale(1.5) !important;
  }

  .type {
    /deep/.el-radio {
      margin-bottom: 20px;
    }
  }

  .img {
    position: relative;
    width: 100px;

    &:hover {
      .redact {
        display: block;
      }
    }

    .redact {
      position: absolute;
      top: 0;
      right: 10px;
      display: none;
    }
  }

  .imgList {
    display: flex;

    .item {
      position: relative;

      .el-icon-circle-close {
        position: absolute;
        top: -10px;
        right: 5px;
        font-size: 20px;
        cursor: pointer;
        z-index: 9;
        color: #B4272D;

      }
    }

    /deep/.el-upload {
      width: 100px;
      height: 100px;
    }

    /deep/.el-upload-dragger {
      width: 98px;
      height: 98px;
      border: none;
    }
  }

  /deep/.ql-editor {
    min-height: 200px !important;
    max-height: 600px !important;
  }
}

.operation {
  text-align: right;
  margin-bottom: 24px;
}

.btn {
  text-align: center;
  width: 1400px;
}

.attribute {
  .row {
    display: flex;
    margin-bottom: 180px;

    .item {
      border: 1px solid #ccc;
      width: 150px;
      position: relative;
      border-left: 0;

      &:nth-child(1) {
        border-left: 1px solid #ccc;
      }

      .title {
        display: flex;
        justify-content: center;
        align-items: center;
        border-bottom: 1px solid #ccc;
        line-height: 40px;
        font-size: 18px;
        margin-bottom: 0;
        position: relative;

        .el-button {
          position: absolute;
          top: 50%;
          right: 10px;
          transform: translate(0, -50%);
        }
      }

      .val {
        padding: 15px;
      }

      .img-box {
        position: absolute;
        bottom: -130px;
        left: 0;
        width: 150px;
        height: 100px;
        display: flex;
        justify-content: center;
        align-items: center;


      }
    }

    .increaseDecrease {
      margin-left: 20px;
    }
  }
}

.inventory {
  .row {
    display: flex;
    padding: 24px 30px;


    &:nth-child(1) {
      border-bottom: 1px solid #ccc;
      padding-top: 0;
    }

    .item {
      flex: 1;
      display: flex;

      &:nth-child(1) {
        margin-right: 24px;
      }

      .label {
        width: 80px;
        line-height: 40px;
      }

      .value {
        flex: 1;
      }

      i {
        font-size: 30px;
        cursor: pointer;
        line-height: 40px;
        margin-left: 20px;
      }
    }
  }
}

.sku {
  .skuItem {
    display: flex;
    margin-bottom: 30px;
    border: 1px solid #ccc;
    padding: 15px;
    border-radius: 10px;

    .attr {
      width: 200px;
      margin-right: 30px;

      .name {
        font-size: 20px;
        font-weight: 700;
        border-right: 1px solid #ccc;
      }
    }

    .del {
      flex: 1;
      text-align: right;
    }
  }
}

/deep/ .image-slot {
  width: 98px;
  height: 98px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #c0ccda;
  border-radius: 4px;

  i {
    font-size: 30px;
    color: #8c939d;
  }
}
</style>